// Keep error message in sync with the one in API: services/followUps.ts
export const APPOINTMENT_ALREADY_SCHEDULED_ERROR_MESSAGE =
  'Appointment already scheduled during this time';
